export default __webpack_public_path__ + "static/hotel_fallback-205045782beea00125ee8b16f542991f.jpg";